import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { Entente } from '../../../../../../../common/src/entities';

const styles = StyleSheet.create({
    table: { width: '100%', margin: 2 },
    tableRow: { flexDirection: 'row', borderBottom: '1 solid black', paddingVertical: 1 },
    tableHeader: { fontWeight: 'bold', backgroundColor: 'black', color: 'white', padding: 2 },
    tableCell: { flex: 1, textAlign: 'center', padding: 1, fontSize: 9 },
    totalRow: { fontWeight: 'bold', backgroundColor: 'black', color: 'white', padding: 1 },
});

export default function PriceTablePDF({ entente, isFacture }: { entente: Entente; isFacture: boolean }) {
    const activiteEntenteProduits = entente.activiteEntentes
        ? entente.activiteEntentes
              .map((ae) => (ae ? ae.activiteEntenteProduit : []))
              .flat()
              .filter(function (element) {
                  return element !== null && element !== undefined;
              })
        : [];

    const subTotal = activiteEntenteProduits.reduce(
        (sum, item) => sum + item.facturation.prix_de_vente_fournisseur * 2,
        0,
    );
    const tps = subTotal * 0.05;
    const tvq = subTotal * 0.09975;
    const total = subTotal + tps + tvq;

    return (
        <>
            <View style={styles.table}>
                <View style={[styles.tableRow, styles.tableHeader]}>
                    <Text style={[styles.tableCell, { flex: 3, textAlign: 'left' }]}>
                        Détails des produits, services ou forfaits
                    </Text>
                    <Text style={styles.tableCell}>Prix unitaire</Text>
                    <Text style={styles.tableCell}>Quantité</Text>
                    <Text style={styles.tableCell}>Prix</Text>
                </View>

                {activiteEntenteProduits.map((item, index) => (
                    <View key={index} style={styles.tableRow}>
                        <Text style={[styles.tableCell, { flex: 3, textAlign: 'left' }]}>{item.produit.name}</Text>
                        <Text style={[styles.tableCell, { textAlign: 'right' }]}>
                            {item.facturation.prix_de_vente_fournisseur} $
                        </Text>
                        <Text style={[styles.tableCell, { textAlign: 'right' }]}>{2}</Text>
                        <Text style={[styles.tableCell, { textAlign: 'right' }]}>
                            {(item.facturation.prix_de_vente_fournisseur * 2).toFixed(2)} $
                        </Text>
                    </View>
                ))}

                <View style={styles.tableRow}>
                    <Text style={[styles.tableCell, { flex: 3 }]}></Text>
                    <Text style={styles.tableCell}></Text>
                    <Text style={[styles.tableCell, { textAlign: 'right' }]}>Sous-total</Text>
                    <Text style={[styles.tableCell, { textAlign: 'right' }]}>{subTotal.toFixed(2)} $</Text>
                </View>

                <View style={styles.tableRow}>
                    <Text style={[styles.tableCell, { flex: 3 }]}></Text>
                    <Text style={styles.tableCell}></Text>
                    <Text style={[styles.tableCell, { textAlign: 'right' }]}>TPS (5%)</Text>
                    <Text style={[styles.tableCell, { textAlign: 'right' }]}>{tps.toFixed(2)} $</Text>
                </View>
                <View style={styles.tableRow}>
                    <Text style={[styles.tableCell, { flex: 3 }]}></Text>
                    <Text style={styles.tableCell}></Text>
                    <Text style={[styles.tableCell, { textAlign: 'right' }]}>TVQ (9.975%)</Text>
                    <Text style={[styles.tableCell, { textAlign: 'right' }]}>{tvq.toFixed(2)} $</Text>
                </View>

                <View style={[styles.tableRow, styles.totalRow]}>
                    {isFacture ? (
                        <>
                            <Text style={[styles.tableCell, { flex: 3 }]}></Text>
                            <Text style={styles.tableCell}></Text>
                        </>
                    ) : (
                        <Text style={[styles.tableCell, { flex: 4, fontSize: 8, textAlign: 'left' }]}>
                            Ce document n'est pas une facture. Demandez une facture avant de faire un paiement.
                        </Text>
                    )}
                    <Text style={styles.tableCell}>Total</Text>
                    <Text style={styles.tableCell}>{total.toFixed(2)} $</Text>
                </View>
            </View>
        </>
    );
}
